<!-- 律所简介管理 -->
<template>
    <div class="intro-management">
        <div class="title">
            简介管理
            <tip
                name="简介"
                demo-pic="https://lvlin-base.cdn.bcebos.com/bend/intro-demo.png"
                class="tip"
            />
        </div>
        <veui-form
            ref="briefIntro"
            class="form"
            :data="formData"
            :validators="validators"
        >
            <veui-field
                label="律所名称"
                name="name"
                class="name"
                :rules="[
                    {name: 'required', triggers: 'blur', message: '   '},
                ]"
            >
                <veui-input
                    v-model="formData.name"
                    ui="l"
                    class="long-input"
                    :disabled="true"
                />
                <div class="help">
                    【律所名称】取自百家号企业资质认证通过后的信息，
                    <span class="link" @click="goLawFirmAuthentication('name')">点击此处</span>进行修改
                </div>
            </veui-field>
            <veui-field
                label="团队名称"
                name="teamName"
                class="team-name"
                :rules="[
                    {name: 'maxLength', value: '30', triggers: 'blur'},
                ]"
            >
                <veui-input
                    v-model="formData.teamName"
                    ui="l"
                    maxlength="30"
                    placeholder="请输入团队名称"
                    class="long-input"
                    :strict="true"
                />
                <div class="help">
                    如果您是团队入驻，该字段为必填项
                </div>
            </veui-field>
            <veui-field
                label="律所头像"
                name="icon"
                class="avatar"
                :rules="[
                    {name: 'required', triggers: 'blur', message: '   '},
                ]"
            >
                <div class="law-firm-avatar">
                    <img :src="formData.icon"/>
                </div>
                <div class="help">
                    【律所头像】取自百家号企业资质认证通过后的信息，
                    <span class="link" @click="goLawFirmAuthentication('avatar')">点击此处</span>进行修改
                </div>
            </veui-field>
            <veui-field
                label="执业许可证"
                name="licenceUrl"
                class="licence"
                :rules="[
                    {name: 'required', triggers: 'blur', message: '   '},
                ]"
            >
                <div class="business_certificate">
                    <img :src="formData.licenceUrl"/>
                </div>
                <div class="help">
                    【执业许可证】取自百家号企业资质认证通过后的信息，
                    <span class="link" @click="goLawFirmAuthentication('business_certificate')">点击此处</span>进行修改
                </div>
            </veui-field>
            <veui-field
                label="律所背景"
                name="bgImgs"
                field="bgImgs"
            >
                <veui-uploader
                    v-model="formData.bgImgs"
                    type="image"
                    :action="`${url}&bucketName=law_smart&storeDir=bgImgs&ajax=true`"
                    ui="m"
                    :max-count="5"
                    max-size="5mb"
                    accept="jpg,png,jpeg"
                    :convert-response="(data) => convertResponse(data, 'bgImgs')"
                    class="bc-pics"
                >
                    <template #desc>
                        <div class="bc-pics-tip">
                            1、图片5M以内，支持jpg/jpeg/png格式<br>2、像素要求414*250<br>3、最多上传5张
                        </div>
                    </template>
                </veui-uploader>
            </veui-field>
            <veui-field
                label="律所介绍"
                name="intro"
                :rules="[
                    {name: 'maxLength', value: '50', triggers: 'blur'},
                    {name: 'required', triggers: 'input,blur'},
                ]"
            >
                <veui-textarea
                    v-model="formData.intro"
                    placeholder="请填写律所介绍"
                    ui="l"
                    maxlength="50"
                    class="long-input introduce"
                    rows="1"
                    :autoresize="true"
                    :strict="true"
                />
            </veui-field>
            <veui-field
                label="律所成立时间"
                name="setupTime"
                field="setupTime"
                :rules="[
                    {name: 'required', triggers: 'blur,change', message: '请选择'},
                ]"
            >
                <veui-date-picker
                    v-model="formData.setupTime"
                    placeholder="选择日期"
                />
            </veui-field>
            <veui-fieldset
                label="每周营业时间"
                class="veui-field-required"
            >
                <veui-field
                    name="weekStart"
                    :rules="[
                        {name: 'required', triggers: 'blur,change', message: '请选择'},
                    ]"
                >
                    <veui-select
                        v-model="formData.weekStart"
                        :options="weeks"
                        class="week-select"
                        placeholder="请选择"
                        @change="weekChange"
                    />
                </veui-field>
                <veui-span class="connect-label">至</veui-span>
                <veui-field
                    name="weekEnd"
                    :rules="[
                        {name: 'required', triggers: 'blur,change', message: '请选择'},
                    ]"
                >
                    <veui-select
                        v-model="formData.weekEnd"
                        :options="endWeeks"
                        placeholder="请选择"
                        class="week-select"
                    />
                </veui-field>
                <veui-field
                    name="timeStart"
                    :rules="[
                        {name: 'required', triggers: 'blur,change', message: '请选择'},
                    ]"
                    class="time-select first"
                >
                    <veui-time-picker
                        v-model="formData.timeStart"
                        mode="minute"
                    />
                </veui-field>
                <veui-span class="connect-label">至</veui-span>
                <veui-field
                    name="timeEnd"
                    :rules="[
                        {name: 'required', triggers: 'blur,change', message: '请选择'},
                    ]"
                    class="time-select"
                >
                    <veui-time-picker
                        v-model="formData.timeEnd"
                        mode="minute"
                        :min="formData.timeStart"
                    />
                </veui-field>
            </veui-fieldset>

            <veui-fieldset
                label="律所地址"
                class="veui-field-required address"
            >
                <veui-field
                    name="addressOption"
                    :rules="[
                        {name: 'required', triggers: 'input,blur'},
                    ]"
                >
                    <Cascader
                        v-model="formData.addressOption"
                        :data="cityOptions"
                        class="city-option"
                        clearable
                    />
                </veui-field>
                <veui-field
                    name="address"
                    :rules="[
                        {name: 'required', triggers: 'input,blur'},
                        {name: 'maxLength', value: 20, message: '最多输入 20 个字符', trigger: 'blur'},
                    ]"
                    class="address-detail"
                >
                    <veui-input
                        v-model="formData.address"
                        ui="l"
                        maxlength="20"
                        placeholder="请输入具体律所所在街道门牌号等"
                        class="address-detail-input"
                        :strict="true"
                    />
                </veui-field>
            </veui-fieldset>
            <veui-field
                label="律所电话"
                name="tel"
                class="tel"
                :rules="[
                    {name: 'required', triggers: 'input,blur'},
                    {
                        name: 'pattern',
                        value: /^((\d{3,4}-\d{7,8})|(1\d{10})|\d{10})$/,
                        message: '{value} 不是正确的手机号',
                        triggers: 'blur',
                    },
                ]"
            >
                <veui-input
                    v-model="formData.tel"
                    ui="l"
                    placeholder="请填写律所电话"
                    :strict="true"
                />
                <p class="help">请填写律所工作人员在上班时间能够实时接通的联系电话</p>
            </veui-field>
            <veui-field
                label="擅长领域选择"
                field="expertArea"
                name="expertArea"
                :rules="[
                    {name: 'required', triggers: 'blur,change', message: '请选择'},
                ]"
            >
                <veui-select
                    v-model="formData.expertArea"
                    data-stat-ignore
                    clearable
                    multiple
                    class="domain-item"
                    @change="expertAreaChange"
                >
                    <veui-option-group
                        v-for="(item, index) in expertArea"
                        :key="index"
                        :label="item.name"
                        position="popup"
                    >
                        <veui-option
                            v-for="item in item.children"
                            :key="item.id"
                            :value="item.name"
                            :label="item.name"
                        />
                    </veui-option-group>
                </veui-select>
            </veui-field>
            <template
                v-for="item, index in formData.domainInfo"
            >
                <veui-field
                    :key="index"
                    :label="item.domain + '描述'"
                    :name="'fieldDescribe' + (index + 1)"
                    :rules="[
                        {name: 'required', value: true, triggers: 'blur,input'},
                        {name: 'maxLength', value: 25, message: '最多输入 25 个字符', trigger: 'blur'},
                    ]"
                >
                    <veui-input
                        :key="index"
                        v-model="formData.domainInfo[index].desc"
                        ui="l"
                        maxlength="25"
                        placeholder="请填写对应擅长领域的详情描述"
                        class="long-input"
                        :strict="true"
                        @change="fieldDescribeChange"
                    />
                </veui-field>
            </template>
            <template #actions>
                <veui-button
                    ui="primary"
                    @click="submit"
                >
                    提交
                </veui-button>
                <veui-button
                    v-if="!isCertification"
                    @click="cancle"
                >
                    取消
                </veui-button>
            </template>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file intro-management.vue
 * @author dingzhenyue
 * @desc 律所简介管理
 */
import {
    Form,
    Field,
    Button,
    Select,
    DatePicker,
    Input,
    Uploader,
    TimePicker,
    Option,
    Fieldset,
    Span,
    Textarea,
    OptionGroup
} from 'veui';
import tip from '@/components/firm/tip';
import {weeks} from '../util/config';
import {isBoolean} from 'lodash';
import toast from 'veui/plugins/toast';
import Vue from 'vue';
import {mapState} from 'vuex';
Vue.use(toast);

export default {
    name: 'introManagement',
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-button': Button,
        'veui-select': Select,
        'veui-date-picker': DatePicker,
        'veui-input': Input,
        'veui-uploader': Uploader,
        'veui-time-picker': TimePicker,
        'veui-fieldset': Fieldset,
        'veui-span': Span,
        'veui-textarea': Textarea,
        'veui-option': Option,
        'veui-option-group': OptionGroup,
        tip
    },
    props: {
        profile: {
            'type': Object,
            'default': function () {
                return {};
            }
        },
        businessId: {
            'type': Number,
            'default': 0
        },
        // 是否是认证阶段
        isCertification: {
            'type': Boolean,
            'default': false
        }
    },
    data() {
        return {
            // 表单数据
            formData: {
                name: '',
                // 团队名称
                teamName: '',
                // 头像
                icon: '',
                licenceUrl: '',
                // 成立时间
                setupTime: null,
                // 选择的省市县
                addressOption: [],
                // 填写的详细地址
                address: '',
                expertArea: [],
                // 背景图
                bgImgs: [],
                // 律所简介
                intro: '',
                // 律所电话
                tel: '',
                // 领域字符串，逗号隔开
                domains: '',
                // 领域描述数组
                domainInfo: [],
                weekStart: null,
                weekEnd: null,
                timeStart: '',
                timeEnd: '',
                // 仅用于校验是否已填
                fieldDescribe1: '',
                fieldDescribe2: '',
                fieldDescribe3: '',
                fieldDescribe4: ''
            },
            // 星期选择组件数据
            weeks,
            // 第二个星期选择组件数据
            endWeeks: [
                {
                    label: '周一',
                    value: '1'
                },
                {
                    label: '周二',
                    value: '2'
                },
                {
                    label: '周三',
                    value: '3'
                },
                {
                    label: '周四',
                    value: '4'
                },
                {
                    label: '周五',
                    value: '5'
                },
                {
                    label: '周六',
                    value: '6'
                },
                {
                    label: '周日',
                    value: '7'
                }
            ],
            // 擅长领域数据
            expertArea: [],
            // 文件上传url
            url: `/bp/api/upload?ajax=1&bdstoken=${window._pageData?.bdstoken}`,
            // 全国城市信息
            cityOptions: [],
            // 特殊校验
            validators: [
                {
                    fields: ['expertArea'],
                    validate: expertArea => {
                        if (expertArea.length >= 2 && expertArea.length <= this.maxFieldsNum) {
                            return true;
                        }

                        return new Promise(resolve => {
                            setTimeout(() => {
                                let res = {
                                    expertArea: expertArea.length < 2 ? '至少选择2个擅长领域' : `最多选择${this.maxFieldsNum}个擅长领域`
                                };
                                resolve(res);
                            });
                        });
                    },
                    triggers: ['change', 'submit']
                },
                {
                    fields: ['setupTime'],
                    handler(setupTime) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                if (setupTime.getTime() < new Date('1922/1/1').getTime()) {
                                    res = {
                                        setupTime: '当前填写的律所成立时间已超100年，请核对是否填写正确'
                                    };
                                }
                                else if (setupTime.getTime() > new Date().getTime()) {
                                    res = {
                                        setupTime: '律所成立时间不能是未来时间'
                                    };
                                }
                                resolve(res);
                            });
                        });
                    },
                    triggers: ['change', 'submit', 'select']
                },
                {
                    fields: ['bgImgs'],
                    handler(bgImgs) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                if (!bgImgs || !bgImgs.length) {
                                    resolve({
                                        bgImgs: '请上传律所背景图片'
                                    });
                                    return;
                                }
                                bgImgs.forEach(item => {
                                    let image = new Image();
                                    image.src = item.src;
                                    image.onload = () => {
                                        let res;
                                        if (image.height !== 250 || image.width !== 414) {
                                            res = {
                                                bgImgs: '图片尺寸应为414*250'
                                            };
                                        }
                                        resolve(res);
                                    };
                                });
                            });
                        });
                    },
                    triggers: ['change', 'submit', 'select']
                }
            ],
            // 提交加锁
            isSubmit: false
        };
    },
    computed: {
        ...mapState({
            maxFieldsNum: state => state.lawStore.vipInfo?.privilege_info?.domain_fields_num || 2,
            userInfo: state => state.lawStore.userInfoNew
        })
    },
    mounted() {
        this.getCity();
        this.getDomain();
    },
    watch: {
        profile: {
            handler(val) {
                this.handleGetData(val);
            },
            immediate: true
        },
        formData: {
            handler() {
                if (!this.isCertification) {
                    return;
                }
                let formFormatData = this.handleSubmitData();
                let uk = this.userInfo.uk;
                let lastFirmInfo = JSON.parse(localStorage.getItem('firmInfo')) || {};
                if (lastFirmInfo[uk]) {
                    lastFirmInfo[uk] = formFormatData;
                }
                else {
                    lastFirmInfo = {
                        ...lastFirmInfo,
                        [uk]: formFormatData
                    };
                }
                localStorage.setItem('firmInfo', JSON.stringify(lastFirmInfo));
            },
            deep: true
        }
    },
    methods: {

        /**
         * 表单提交
         * @param {Object} event 原生事件对象
         */

        submit() {
            this.formData.domains = '';
            if (this.formData?.domainInfo?.length) {
                this.formData.domainInfo.forEach((element, index) => {
                    // 绑定描述值，用于校验
                    this.formData['fieldDescribe' + (index + 1)] = element.desc;
                    // 赋值domains
                    this.formData.domains += this.formData.domains ? ',' + element.domain : element.domain;
                });
            }
            this.$refs.briefIntro.validate().then(valid => {
                // 校验数据
                if (!isBoolean(valid)) {
                    this.$toast.error('有字段填写不符合标准，请重新填写');
                    return false;
                }
                let data = this.handleSubmitData();
                this.setData(data);
            });
        },

        /**
         * 取消修改
         */

        cancle() {
            this.$refs.briefIntro.clearValidities();
            this.$emit('cancle');
        },

        /**
         * 第一个星期组件选中值改变时触发，修改第二个星期组件的可选中值
         *
         * @param {String} selectWeek 选中值
         */

        weekChange(selectWeek) {
            // 当结束时间早于开始时间时
            if (+this.formData.weekEnd < +selectWeek) {
                this.formData.weekEnd = selectWeek + '';
            }
            this.endWeeks.forEach((item, index) => {
                this.$set(this.endWeeks, index, {
                    ...item,
                    disabled: +item.value < +selectWeek
                });
            });
        },

        /**
         * 获取全国城市数据
         */

        getCity() {
            this.$http.get('/bp/api/city/cityAll', {
            }).then(res => {
                if (!res || +res.code !== 0) {
                    return;
                }
                let data = res?.data;
                if (data) {
                    this.cityOptions = data;
                }
            }).catch(err => this.$normalizeResponseError(err));
        },

        /**
         * 擅长领域checkBox改变时
         * @param {Array} data 选中值
         */

        expertAreaChange(data) {
            let domainInfo = this.formData?.domainInfo || [];
            // 新增一项
            if (data.length > domainInfo.length) {
                domainInfo.push({
                    // 领域名称
                    domain: data[data.length - 1],
                    // 领域描述
                    desc: ''
                });
                this.formData.domainInfo = domainInfo;
            }
            // 清空
            else if (data.length === 0) {
                this.formData.domainInfo = [];
            }
            // 减少一项
            else {
                for (let i = 0; i < domainInfo.length; i++) {
                    let preItem = domainInfo[i].domain;
                    let exit = false;
                    for (let j = 0; j < data.length; j++) {
                        let curItem = data[j];
                        if (preItem === curItem) {
                            exit = true;
                            break;
                        }
                    }
                    if (!exit) {
                        this.formData.domainInfo = domainInfo.filter(item => item.domain !== preItem);
                    }
                }
            }
        },

        /**
         * 处理获取到的数据
         */

        handleGetData(data) {
            let {provCode, cityCode, districtCode} = data || {};
            let [week, time] = data?.businessWeek?.split(' ') || [];
            let [weekStart, weekEnd] = week?.split('至') || [];
            let [timeStart, timeEnd] = time?.split('-') || [];
            data = {
                ...data,
                addressOption: +provCode ? [+provCode, +cityCode, +districtCode] : [],
                setupTime: +data.setupTime ? new Date(+data.setupTime * 1000) : null,
                bgImgs: data.bgImgs && (Array.isArray(data.bgImgs) ? data.bgImgs : data.bgImgs.split(',')) || [],
                weekStart: weekStart ? this.weeks.filter(item => item.label === weekStart)[0].value : null,
                weekEnd: weekEnd ? this.weeks.filter(item => item.label === weekEnd)[0].value : null,
                timeStart: timeStart || '',
                timeEnd: timeEnd || '',
                expertArea: []
            };
            // 背景图格式处理
            if (data.bgImgs && data.bgImgs.length) {
                data.bgImgs.forEach((item, index) => {
                    data.bgImgs[index] = {
                        src: item,
                        key: index
                    };
                });
            }
            // 擅长领域格式处理
            if (data.domainInfo) {
                data.domainInfo = Array.isArray(data.domainInfo) ? data.domainInfo : JSON.parse(data.domainInfo);
                data.domainInfo.forEach((item, index) => {
                    data['fieldDescribe' + (index + 1)] = item.desc;
                    data.expertArea.push(item.domain);
                });
            }
            this.formData = data;
        },

        fieldDescribeChange() {
            const data = this.formData || {};
            if (data.domainInfo) {
                data.domainInfo.forEach((item, index) => {
                    data['fieldDescribe' + (index + 1)] = item.desc;
                });
            }
        },

        /**
         * 处理提交数据
         */

        handleSubmitData() {
            let data = this.formData;
            let [provCode, cityCode, districtCode] = data?.addressOption;
            let weekStart = this.weeks.filter(item => item.value === data.weekStart)[0]?.label || '';
            let weekEnd = this.weeks.filter(item => item.value === data.weekEnd)[0]?.label || '';
            let bgImgs = [];
            data.bgImgs.forEach(item => {
                bgImgs.push(item.src);
            });
            data = {
                ...data,
                provCode: provCode ? provCode + '' : '',
                cityCode: cityCode ? cityCode + '' : '',
                districtCode: districtCode ? districtCode + '' : '',
                setupTime: data.setupTime ? Math.floor(data.setupTime.getTime() / 1000) + '' : '',
                businessWeek: `${weekStart}至${weekEnd} ${data.timeStart}-${data.timeEnd}`,
                domainInfo: JSON.stringify(data.domainInfo),
                bgImgs: bgImgs.join(',')
            };

            // 选择的领域打点
            this.$log && this.$log.send({
                type: 'clk',
                value: 'domain-select',
                ext: {
                    domains: data.domains
                }
            });
            return data;
        },

        /**
         * 提交表单数据
         *
         * @param {Object} data 表单数据
         */

        setData(data) {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            this.$http.post('/bp/api/business/setprofile', {
                ...data,
                business_id: this.businessId
            }).then(res => {
                if (!res || +res.code !== 0) {
                    // 提交失败
                    this.$toast.error('提交失败，请稍候再试');
                    return;
                }
                if (!this.isCertification) {
                    this.$toast.success('简介提交成功');
                }
                this.$emit('submit');
            }).catch(err => {
                this.$toast.error('提交失败，请稍候再试');
            }).finally(() => {
                this.isSubmit = false;
            });
        },
        convertResponse(data, key) {
            return ({
                success: data && (Number(data.code) === 0),
                src: data && data.data && data.data.bos_url,
                message: data.msg
            });
        },

        /**
         * 跳转百家号认证页面
         */

        goLawFirmAuthentication(area) {
            this.$log && this.$log.send({
                type: 'clk',
                value: 'modify-btn',
                ext: {
                    area
                },
                page: 'firmintro'
            });
            // 认证阶段，直接跳转到百家号
            if (this.isCertification) {
                window.open('https://baijiahao.baidu.com/builder/rc/settings/accountSet');
            }
            else {
                this.$router.push({
                    name: 'lawFirmAuthentication'
                });
            }
        },

        /**
         * 获取领域列表
         */

        getDomain() {
            this.$http.get('/bp/api/lawyer/get_lawyer_domain', {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (res) {
                    let data =  res;
                    this.expertArea = data;
                }
            });
        }
    }
};
</script>

<style lang='less' scoped>
    .intro-management {
        background: #fff;
        min-height: 700px;
        font-size: 14px;

        .form {
            margin-left: 17px;

            .name,
            .avatar,
            .licence,
            .team-name {
                /deep/ .veui-field-content {
                    display: block;
                }
            }

            /deep/ .veui-form-actions {
                text-align: center;

                .veui-button {
                    width: 90px;
                    height: 32px;
                }
            }

            /deep/ .veui-input-content {
                font-size: 14px;
                text-align: left;
            }

            .law-firm-avatar {
                height: 80px;
                width: 80px;

                img {
                    height: 100%;
                    width: 100%;
                }
            }

            .week-select {
                width: 98px;
            }

            .connect-label {
                padding: 0 12px;
            }

            .time-select {
                width: 120px;

                &.first {
                    margin-left: 25px;
                }
            }

            .address-detail {
                margin-left: 25px !important;

                .address-detail-input {
                    width: 462px;
                }
            }

            .city-option {
                width: 234px;
            }

            .long-input {
                width: 720px;
            }

            .expert-area-checkbox {
                width: 720px;
            }

            /deep/ .veui-textarea-count {
                color: #848b99;
                font-size: 16px;
                background: #fff;
            }

            /deep/ .bc-pics .veui-uploader-list-media-item,
            /deep/ .business_certificate .veui-uploader-list-media-item {
                height: 81px;
                width: 134px;
                margin: 24px 0 0 13px;
                position: relative;

                .veui-uploader-list-media-container {
                    height: 100%;
                    width: 100%;
                    border-radius: 8px;
                }
            }

            /deep/ .bc-pics .bc-pics-tip {
                position: absolute;
                top: 0;
                width: 150px;
            }

            .business_certificate {
                height: 81px;
                width: 134px;
                border-radius: 8px;
                text-align: center;
                border: 1px solid #e2e6f0;

                img {
                    height: 79px;
                }
            }

            /deep/ .veui-uploader-media .veui-uploader-desc {
                height: 81px;
                min-width: 12em;
                margin-left: 20px;
            }

            /deep/ .veui-input {
                min-height: 40px;

                .veui-tag {
                    height: 32px;
                }
            }

            /deep/.domain-item {
                .veui-input {
                    padding-bottom: 4px;
                }

                &.veui-select {
                    width: 720px;
                }
            }
        }

        /deep/ .veui-form-actions {
            padding-left: 0;
        }

        .help {
            color: #848b99;
            margin-top: 8px;

            .link {
                color: #3855d5;
                cursor: pointer;
            }
        }

        .tel {
            .help {
                margin-left: 20px;
                margin-top: 0;
            }
        }

        /deep/ .ivu-input-wrapper .ivu-input:focus,
        /deep/.veui-select.veui-select-expanded .veui-input {
            border: 1px solid #0052cc;
            box-shadow: 0 0 0 2px rgba(0, 102, 255, 20%);
        }
    }
</style>
<style lang="less">
    .intro-management {
        .city-option .ivu-input {
            border: 1px solid #d3d9e6;
            height: 36px;
            border-radius: 6px;
        }
    }
</style>